import { createExperimentHook } from '@prisjakt/ui-experiment';

export const useProductCollectionSuggestionsV2Experiment = createExperimentHook(
  'suggest-product-collections-v2',
  false,
  {
    showProductCollectionSuggestions: true,
  }
);

export const useIncludePriceOnProductSuggestions = createExperimentHook(
  'suggest-show-product-prices',
  false,
  {
    showPrices: true,
  }
);

export const useNewResponseFormatForSuggestions = createExperimentHook(
  'new-format-for-suggestions',
  false,
  {
    useNewFormat: true,
  }
);

export const useSplitPriceList = createExperimentHook(
  'split-price-list',
  false,
  {
    splitList: true,
  }
);

export const useAlternativeFacetNavigation = createExperimentHook(
  'alternative-facet-navigation',
  false,
  {
    useAlternativeFacetNavigation: true,
  }
);
